
export const swalTitle = {
    Eliminado: 'Eliminado!',
    Actualizado: 'Actualizado!',
    CreadoCorrectamente: 'Creado correctamente!',
    Enviado: 'Enviado!',
    Loading: 'Espere, por favor.'
}